export default __webpack_public_path__ + "bf267764e150a59fbd1d218eec7176f0.png";